module.exports = __webpack_public_path__ + "img/logo_male.18bca5ee.svg";